package de.oevbs.kunde.kundenportal2.services.account.delete

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.account.DeleteAccount
import de.oevbs.kunde.kundenportal2.model.services.account.currentPassword
import de.oevbs.kunde.kundenportal2.navigation.Page
import dev.fritz2.core.RenderContext

fun RenderContext.accountDeletePage(page: Page) {
    val deleteStore = DeleteStore(job)

    headerImageLayout {
        title(page.linkTitle)
        content {
            contentContainer {
                paragraph {
                    +"Wenn Sie Ihren Account für "
                    span("bold") { +"Meine Öffentliche" }
                    +" löschen, hat dies keine Auswirkungen auf Ihre Versicherungen. "
                    +"""Bei einer Neuregistrierung für das Kundenportal müssen Sie Ihre Verträge allerdings erneut
                        | verknüpfen.""".trimMargin()
                }

                inputPassword {
                    label("Bitte geben Sie Ihr aktuelles Passwort ein, um Ihren Account zu löschen.")
                    value(deleteStore.map(DeleteAccount.currentPassword()))
                }

                buttonContainer {
                    btn {
                        label("Account löschen")
                        busy(globalSubmitTracker.data)
                    }.clicks handledBy deleteStore.submitDeleteAccountRequest
                }
            }
        }
    }
}